import { Component, OnInit, ElementRef, OnDestroy, Input } from '@angular/core';
import keys from 'lodash-es/keys';
import get from 'lodash-es/get';
import isArray from 'lodash-es/isArray';
import { Subject } from 'rxjs';

import { ModalChildComponent } from '@finder/shared/components/modal/modal-child-component.interface';
import { ModalComponent } from '@finder/shared/components/modal/modal.component';
import { SCHEDULE_TYPES } from '@finder/shared/constants/app.constants';
import { ScheduleService } from '@finder/shared/services/schedule/schedule.service';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'finder-showtimes-modal',
    templateUrl: './showtimes-modal.component.html',
    styleUrls: ['./showtimes-modal.component.scss']
})
export class ShowtimesModalComponent implements OnInit, OnDestroy, ModalChildComponent {

    @Input() data;

    parentComponent: ModalComponent;
    schedules: any;
    scheduleKeys: Array<string>;
    showSchedules = false;
    closedSchedule = false;
    scheduleLabels: any;
    types: any;
    scheduleTypes: Array<string>;
    scheduleGroupTypes: Array<string>;
    scheduleGroupKeys: any;
    labels: any = {};

    private $destroy = new Subject<void>();

    constructor(
        public scheduleService: ScheduleService,
        private elementRef: ElementRef,
    ) { }

    ngOnInit() {
        this.setupModalData();
        this.scheduleService.scheduleUpdated
            .pipe(takeUntil(this.$destroy))
            .subscribe((data: any) => {
                this.setupModalData();
            });
    }

    ngOnDestroy() {
        this.$destroy.next();
        this.$destroy.complete();
    }

    setupModalData() {
        this.scheduleTypes = [];
        this.scheduleGroupTypes = [];

        this.types = SCHEDULE_TYPES;
        this.labels = get(this.scheduleService, 'schedule.labels', {});
        this.schedules = get(this.scheduleService, 'schedule.schedules', {});
        this.scheduleLabels = this.scheduleService.getScheduleLabels(this.labels);
        this.scheduleGroupKeys = get(this.scheduleService, 'schedule.scheduleGroupKeys', {});
        this.scheduleKeys = keys(this.schedules);
        this.closedSchedule = this.scheduleKeys.indexOf(this.types.closedSchedule) !== -1 &&
            this.scheduleKeys.length === 1;
        this.showSchedules = this.scheduleKeys && this.scheduleKeys.length > 0 && !this.closedSchedule;

        this.scheduleKeys.forEach(key => {
            // group keys that has array of schedules and
            // the ones that has and object with group keys.
            if (isArray(this.schedules[key])) {
                this.scheduleTypes.push(key);
            } else {
                this.scheduleGroupTypes.push(key);
            }
        });
    }

    onDateChanged(event) {
        this.scheduleService.date = event;
        this.scheduleService.getSchedules(event);
    }

    onCalendarClose(event) {
        const inputElement = this.elementRef.nativeElement.querySelector('.calendar-button input');
        if (inputElement) {
            inputElement.focus();
        }
    }
}
